<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> {{ title }} </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xl="6" lg="6">
                <v-text-field
                  dense
                  outlined
                  type="date"
                  label="Fecha de envasado"
                  clearable
                  :rules="validation()"
                  v-model="packingDate"
                ></v-text-field>
              </v-col>
              <v-col xl="6" lg="6">
                <v-text-field
                  dense
                  outlined
                  type="number"
                  label="Canitdad de dosis utilizada"
                  clearable
                  :rules="validation()"
                  v-model="dosesQuantity"
                ></v-text-field>
              </v-col>
              <v-col xl="6" lg="6">
                <v-combobox
                  label="Seleciona la linea del lote"
                  dense
                  outlined
                  return-object
                  v-model="lineState"
                  clearable
                  :items="lines"
                  :rules="validation()"
                  item-text="name"
                ></v-combobox>
              </v-col>
              <v-col xl="6" lg="6">
                <v-combobox
                  outlined
                  item-text="name"
                  label="Selecciona presentación"
                  return-object
                  clearable
                  :items="presentations"
                  v-model="presentation"
                  dense
                  :disabled="lineState ? false : true"
                  :rules="validation()"
                ></v-combobox>
              </v-col>
              <v-col xl="6" lg="6">
                <v-text-field
                  dense
                  outlined
                  type="number"
                  label="Número de unidades envasadas"
                  clearable
                  :rules="validation()"
                  v-model="numberOfUnitsPackaged"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapState } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    loader: false,
    isLoading: false,
    packingDate: null,
    dosesQuantity: null,
    presentation: null,
    numberOfUnitsPackaged: null,
    presentations: [],
    presentationsS: [
      { name: "250 g", value: "250", units: "g" },
      { name: "500 g", value: "500", units: "g" },
      { name: "2 kg", value: "2000", units: "g" },
    ],
    presentationsL: [
      { name: "5 L", value: "5000", units: "ml" },
    ],
    lines: [
      { name: "Solida", value: "S" },
      { name: "Liquida", value: "L" },
    ],
    lineState: null,
  }),
  props: {
    value: Boolean,
    title: String,
  },
  computed: {
    ...mapState("lotes", ["loteSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeModal() {
      this.show = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    confirmation() {
      if (this.$refs.form.validate()) {
        //emit desision
        this.$emit("confirmation", {
          packingDate: this.packingDate,
          dosesQuantity: this.dosesQuantity,
          presentation: this.presentation,
          numberOfUnitsPackaged: this.numberOfUnitsPackaged,
          lineState:this.lineState.value
        });
        this.closeModal();
      }
    },
  },
  watch: {
    lineState() {
      if (this.lineState.value == "S") {
        this.presentations = this.presentationsS;
      } else {
        this.presentations = this.presentationsL;
      }
    },
  },
};
</script>
